module.exports = __webpack_public_path__ + "img/item_art_crafts.b3c2679b.png";